import React from 'react';

const ServiceAreas = () => {
  const areas = [
    {
      title: "Oil & Gas",
      subtitle: "Upstream/Midstream/Downstream",
      icon: "fas fa-oil-can",
      color: "from-blue-600 to-blue-800"
    },
    {
      title: "Petrochemicals",
      subtitle: "Complex processing facilities",
      icon: "fas fa-flask",
      color: "from-purple-600 to-purple-800"
    },
    {
      title: "Chemicals",
      subtitle: "Specialty and bulk chemicals",
      icon: "fas fa-atom",
      color: "from-green-600 to-green-800"
    },
    {
      title: "Gas-to-Liquids",
      subtitle: "GTL conversion plants",
      icon: "fas fa-industry",
      color: "from-orange-600 to-orange-800"
    }
  ];

  return (
    <section className="min-h-screen flex items-center py-20 px-4 sm:px-6 lg:px-8 bg-gray-900">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Service Areas</h2>
          <p className="text-xl text-gray-300">Specialized expertise across process industries</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {areas.map((area, index) => (
            <div key={index} className="relative group">
              <div className={`absolute inset-0 bg-gradient-to-br ${area.color} rounded-lg opacity-90 group-hover:opacity-100 transition-opacity`}></div>
              <div className="relative bg-white/10 backdrop-blur-sm p-8 rounded-lg hover:transform hover:scale-105 transition-all duration-300">
                <i className={`${area.icon} text-4xl text-white mb-4 block`}></i>
                <h3 className="text-xl font-bold text-white mb-2">{area.title}</h3>
                <p className="text-gray-200 text-sm">{area.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 relative">
          <img
            src="/assets/asset-14.jpg"
            alt="Industry collage"
            className="w-full rounded-lg shadow-2xl opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-transparent to-gray-900/80 rounded-lg"></div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
